import { render, staticRenderFns } from "./FoodTotalReport.vue?vue&type=template&id=85b50b2c&scoped=true&"
import script from "./FoodTotalReport.vue?vue&type=script&lang=js&"
export * from "./FoodTotalReport.vue?vue&type=script&lang=js&"
import style0 from "./FoodTotalReport.vue?vue&type=style&index=0&id=85b50b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b50b2c",
  null
  
)

export default component.exports